import React from "react";
import { upcomingEvents } from "../data/site";
import { EventsSection } from "../components/events/EventsSection";
import { SiteHeader } from "../components/header/SiteHeader";
import { AccidentHelp } from "../components/home/AccidentHelp";
import { CaseReviewSection } from "../components/home/CaseReviewSection";
import { CommonAnswers } from "../components/home/CommonAnswers";
import { ContactProcess } from "../components/home/ContactProcess";
import { Hero } from "../components/home/Hero";
import { TrustSection } from "../components/home/TrustSection";
import { SiteStatement } from "../components/SiteStatement";
import { SiteFooter } from "../components/SiteFooter";
type HomeProps = {
  showReviewNotes: boolean;
  showEmptyEvents: boolean;
};
export function Home({
  showReviewNotes,
  showEmptyEvents
}: HomeProps) {
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-227" data-mp="3kv0mz173i8qw">
      <a href="#main" className="sr-only left-4 top-4 z-50 rounded-md bg-ink px-5 py-3 text-label font-bold text-white focus:not-sr-only focus:absolute" data-id="element-228" data-mp="3ow43zr0vqatp">
        Skip to main content
      </a>
      <SiteStatement data-id="element-229" data-mp="2vyzz5rz58ldz" />
      <SiteHeader data-id="element-230" data-mp="2vyhse1euuort" />
      <main id="main" data-id="element-231" data-mp="2vvvocbr6arec">
        <Hero data-id="element-232" data-mp="2qy2ijjts7zel" />
        <TrustSection data-id="element-233" data-mp="2qxu4holxao1t" />
        <AccidentHelp data-id="element-234" data-mp="2qx0tgbfxlcdv" />
        <ContactProcess data-id="element-235" data-mp="2r0oo5dx444u6" />
        <CommonAnswers data-id="element-236" data-mp="2mxa6yjxftif5" />
        <EventsSection events={showEmptyEvents ? [] : upcomingEvents} data-id="element-237" data-mp="2mvysnq6d8s9s" />
        <CaseReviewSection showReviewNotes={showReviewNotes} data-id="element-238" data-mp="2hxnjzirt4nt5" />
      </main>
      <SiteFooter data-id="element-239" data-mp="2i0070acf9od2" />
    </div>;
}